import './App.css';
import {
  BrowserRouter,
  Routes,
  Route,
} from "react-router-dom";
import JoinChat from './components/JoinChat'
import Chat from './components/Chat'

const  App = () => {
  return (
    <BrowserRouter>
    <Routes>
     
        <Route exact path = "/" element = {<JoinChat/>} />
        <Route path="/chat" element={<Chat />}/>
          
  
      
    </Routes>
  </BrowserRouter>

  );
}

export default App;
